var isKind = require('./isKind');
    /**
     */
    function isFunction(val) {
        return isKind(val, 'Function');
    }
    module.exports = isFunction;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isFunction.js
// module id = 389
// module chunks = 0 1 2